import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { useParams, useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import PaymentForm from '../PaymentForm';

const PaymentInfo = () => {
  return (
    <Observer
      render={() => {
        const { paymentID } = useParams();
        const history = useHistory();
        const { authStore, dataStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [payment, setPayment] = useState(null);
        const fetchPayment = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/payment/${paymentID}`,
            );
            setPayment(data);
          } catch (e) {
            console.error(e);
          }
        };
        useEffect(() => {
          const initialActions = async () => {
            await fetchPayment();
            setLoading(false);
          };
          initialActions();
        }, []);
        if (isLoading || !payment) return <Spinner />;
        return (
          <FlexDiv>
            <div
              style={{
                width: '100%',
                maxWidth: '1400px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <WideBox
                showoverflow={1}
                style={{ justifyContent: 'center', maxWidth: '700px' }}
              >
                <PaymentForm
                  payment={payment}
                  buttons={[
                    <Button
                      color="secondary"
                      variant="outlined"
                      onClick={() => history.goBack()}
                      size="large"
                    >
                      Cancel
                    </Button>,
                  ]}
                  onSubmit={async values => {
                    const {
                      PaymentId,
                      Contact,
                      ContactId,
                      PaymentDate,
                      DepositDate,
                      ClearedDate,
                      Amount,
                      Description,
                      StatusId,
                      TypeId,
                      TranType,
                      IsCleared,
                      AccountId,
                      PaymentVouchers,
                    } = values;
                    try {
                      await authStore.request.post(
                        `${process.env.REACT_APP_API}/api/payment`,
                        {
                          PaymentId,
                          Contact,
                          ContactId,
                          PaymentDate,
                          DepositDate,
                          ClearedDate,
                          Amount,
                          Description,
                          StatusId,
                          TypeId,
                          TranType,
                          IsCleared,
                          AccountId,
                          PaymentVouchers,
                        },
                      );
                      await dataStore.retrieveAllPayments();
                      history.push('/payments');
                    } catch (e) {
                      console.error(e);
                    }
                  }}
                />
              </WideBox>
            </div>
          </FlexDiv>
        );
      }}
    />
  );
};

export default PaymentInfo;

//  <ApplyToVoucher payment={payment} />
